<template>
    <b-row class="mb-1">
        <b-col
            v-for="(cmp, index) in selectComponents"
            :key="index"
            :md="cmp[1]"
            :class="{
                'pr-md-0': index < selectComponents.length - 1
            }"
        >
            <component
                :is="cmp[0]"
                :clearable="isClearable(cmp[0], cmpArr)"
                :storeKey=cmp[2]
            ></component>
        </b-col>
    </b-row>
</template>
<script>
import { computed, getCurrentInstance } from '@vue/composition-api'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
const CommonSelectGroup = () => import('./CommonSelectGroup.vue')
const CommonSelectProject = () => import('./CommonSelectProject.vue')
const CommonSelectMonth = () => import('./CommonSelectMonth.vue')
const CommonSelectCalendarMonth = () => import('./CommonSelectCalendarMonth.vue')
const CommonSelectCalendarMonthRange = () => import('./CommonSelectCalendarMonthRange.vue')
const CommonSelectCalendarYear = () => import('./CommonSelectCalendarYear.vue')
export default {
    components: {
        CommonSelectGroup,
        CommonSelectProject,
        CommonSelectMonth,
        CommonSelectCalendarMonth,
        CommonSelectCalendarMonthRange,
        CommonSelectCalendarYear
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const selectComponentMap = {
            'month': [
                ['common-select-calendar-month', 2]
            ],
            'project-month': [
                ['common-select-project', 10],
                ['common-select-calendar-month', 2]
            ],
            'group-project-month': [
                ['common-select-group', 4],
                ['common-select-project', 6],
                ['common-select-calendar-month', 2]
            ],
            'group-project-monthrange': [
                ['common-select-group', 4],
                ['common-select-project', 6],
                ['common-select-calendar-month-range', 2, '$_costPivot']
            ],
            'group-project': [
                ['common-select-group', 6],
                ['common-select-project', 6]
            ],
            'project-year': [
                ['common-select-project', 10],
                ['common-select-calendar-year', 2, '$_invoice']
            ]
        }
        const selectComponents = computed(() => selectComponentMap[vm.$route.meta.selectType])
        const cmpArr = computed(() => selectComponents.value?.map(cmp => cmp[0]) || [])
        const { isClearable } = useSelectProjectAndGroup()
        return {
            selectComponents,
            isClearable,
            cmpArr
        }
    }
}

</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
